import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";
import { Button } from "../ui";
import { useState } from "react";
import type { ReactNode } from "react";

export function DeleteConfirm({
  trigger = null,
  children = null,
  open,
  onOpenChange,
  onConfirm,
  title,
  buttonTitle,
  description,
}: {
  trigger?: ReactNode;
  children?: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  onConfirm: () => void;
  title: string;
  buttonTitle?: string;
  description: string;
}) {
  const { t } = useTranslation();
  const [localOpen, setLocalOpen] = useState(open ?? false);
  function handleOnOpenChange(isOpen: boolean) {
    setLocalOpen(isOpen);
    onOpenChange?.(isOpen);
  }

  function localConfirm() {
    onConfirm();
    handleOnOpenChange(false);
  }

  return (
    <AlertDialog open={localOpen} onOpenChange={handleOnOpenChange}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t(title)}</AlertDialogTitle>
          <AlertDialogDescription>{t(description)}</AlertDialogDescription>
        </AlertDialogHeader>

        {children}

        <AlertDialogFooter>
          <AlertDialogCancel>{t("common.cancel")}</AlertDialogCancel>
          <Button variant="destructive" onClick={localConfirm}>
            {buttonTitle ? t(buttonTitle) : t("common.delete")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
